import { useTranslation } from "react-i18next";
import { getSummaryTemplates } from "@/constants/summaryTemplates";
import type { TemplateKey } from "@/types";

interface TemplatePickerProps {
  selected: TemplateKey;
  onChange: (key: TemplateKey) => void;
}

export function TemplatePicker({ selected, onChange }: TemplatePickerProps) {
  const { t } = useTranslation();
  const templates = getSummaryTemplates();
  const current = templates.find((tpl) => tpl.key === selected);

  // Re-read labels on render to pick up language changes
  void t;

  return (
    <div>
      <label className="text-sm font-medium text-redi-text mb-2 block">
        {t("record.templateLabel")}
      </label>
      <div className="flex gap-2 flex-wrap">
        {templates.map((tpl) => (
          <button
            key={tpl.key}
            onClick={() => onChange(tpl.key)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              selected === tpl.key
                ? "bg-redi-primary text-white"
                : "bg-redi-surface text-redi-muted hover:text-redi-text"
            }`}
          >
            {tpl.label}
          </button>
        ))}
      </div>
      {current && (
        <p className="text-xs text-redi-muted mt-2">{current.description}</p>
      )}
    </div>
  );
}
